<script setup lang="ts">
  import UpsellCard from '@/components/common/UpsellCard.vue';
  import { useDisputesAccessRequest } from '@/composables/useDisputesAccessRequest';

  interface Props {
    compact?: boolean;
  }

  withDefaults(defineProps<Props>(), {
    compact: false,
  });

  const description = `
    Let the agent run your disputes. Upgrade to let the agent handle your disputes end-to-end
    — from the moment one lands in your inbox to the moment it's resolved. Your team stays
    focused on what only they can do.`;

  const { requestAccess } = useDisputesAccessRequest();
</script>

<template>
  <UpsellCard
    :compact="compact"
    title="Put disputes on autopilot"
    :description="description"
    :features="[
      'Catches and routes each case to the right team using your Playbook',
      'Watches every case 24/7 — closes it the moment payment or resolution lands',
      'Suggests resolutions based on how you\'ve handled things before',
    ]"
    cta-text="Upgrade to Disputes Pro"
    @cta-action="requestAccess"
  />
</template>
